import { PureComponent } from 'react';
import { closeFileUpload, openFileUpload } from './actions';

import FileUploadOverlay from 'containers/FileUploadOverlay';
import { uploadCA } from 'containers/FileUploadOverlay/actions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import handleEvent from 'utils/handleEvent';
import { makeSelectShowFileUpload } from './selectors';

class FileUpload extends PureComponent {
  static propTypes = {
    onCloseFileUpload: PropTypes.func.isRequired,
    onUploadCA: PropTypes.func.isRequired,
    showFileUpload: PropTypes.bool.isRequired,
  };

  componentWillUnmount() {
    this.props.onCloseFileUpload();
  }

  handleCancelUpload = handleEvent(() => {
    this.props.onCloseFileUpload();
  });

  handleUpload = handleEvent((fileUploadName, fileUpload) => {
    const { onUploadCA, onCloseFileUpload } = this.props;
    onUploadCA({
      data: {
        content: fileUpload,
        name: fileUploadName,
      },
    });
    onCloseFileUpload();
  });

  render() {
    const { showFileUpload } = this.props;
    if (showFileUpload) {
      return (
        <FileUploadOverlay
          onClose={this.handleCancelUpload}
          onUpload={this.handleUpload}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = createStructuredSelector({
  showFileUpload: makeSelectShowFileUpload(),
});

function mapDispatchToProps(dispatch) {
  return {
    onOpenFileUpload: () => dispatch(openFileUpload()),
    onCloseFileUpload: () => dispatch(closeFileUpload()),
    onUploadCA: (args) => dispatch(uploadCA(args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);
